export default {
  overview: {
    title: "Personalrollen Übersicht",
    archive_title: "Archivierte Personalrollen",
    subtitle: "Auflistung aller Personalrollen.",
    actions: {
      create_new: "Neue Personalrolle erstellen",
    },
    search: {
      placeholder: "bspw. Name",
    },
    table: {
      headers: {
        name: "Rolle",
        hourlyRate: "Stundensatz",
        employees: "Mitarbeiter",
        createdAt: "Erstellt am",
      },
      employees: "{n} Mitarbeiter | {n} Mitarbeiter",
      empty: {
        hourlyRate: "Nicht gesetzt",
        employees: "Niemand",
      },
    },
  },
  detail: {
    title: "Personalrolle Details",
    tabs: {
      general: "Allgemein",
      activity: "Protokoll",
    },
    actions: {
      update: "Speichern",
    },
    form: {
      name: "Name",
      hourlyRate: "Stundensatz",
    },
  },
  create: {
    title: "Personalrolle Anlegen",
    subtitle: "Neue Personalrolle anlegen.",
  },
}
